<template>
  <div class="container-z">
    <Banner/>
    <Header/>
    <div class="i_box01">
      <div class="i_about" id="com_singles_company" editok="online">
        <div class="title01">
          <ins class="ticon01"></ins>
          <h3>国内资讯</h3>
          <span>
              <a href="/#/guoNeiZiXun" class="more">MORE</a>
            </span>
        </div>
        <div class="i_about_c">
          <ul>
            <li v-for="(item, index) in listData.guoNeiZiXun" :key="index" class="h3-out">
              <span v-if="index <= 7" class="h3">
                <a :href="'/#/detail?id=' + item.ID" :title="item.post_title">{{ item.post_title }}
                </a>
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div class="i_news">
        <div class="title01">
          <ins class="ticon02"></ins>
          <h3>国外资讯</h3><span><a href="/#/guoWaiZiXun" class="more">MORE</a></span></div>
        <div class="i_news_l">
          <div class="i_news_l_list" id="com_indexistop_news" editok="online">
            <ul>
              <li v-for="(item, index) in listData.guoWaiZiXun" :key="index" class="h3-out">
                <a v-if="index <= 7" :href="'/#/detail?id=' + item.ID" :title="item.post_title">
                  {{ item.post_title }}
                </a>
                <b v-if="index <= 7">{{ item.post_date.split(' ')[0] }}</b>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="i_score" id="com_singles_score" editok="online">
        <div class="title01">
          <ins class="ticon03"></ins>
          <h3>最新资讯</h3>
          <span class="score">
            <a href="/#/zuiXinZiXun" class="more">MORE</a>
          </span>
        </div>
        <div class="i_news_l">
          <div class="i_news_l_list1" id="com_indexistop_news" editok="online">
            <ul>
              <li v-for="(item, index) in listData.zuiXinZiXun" :key="index" class="h3-out">
                <a v-if="index <= 7" :href="'/#/detail?id=' + item.ID" :title="item.post_title">
                  {{ item.post_title }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="edit_nullmodule" id="com_definedkeys_1" editok="online">
    </div>
    <div class="clear"></div>
    <div class="i_box01">
      <div class="i_video" id="com_indexistop_videos" editok="online">
        <div class="title01">
          <ins class="ticon04"></ins>
          <h3>行业资讯</h3>
          <span>
           <a href="/#/hangYeZiXun" class="more">MORE</a>
          </span>
        </div>
        <div class="i_video_l">
          <div class="i_video_l_list">
            <ul>
              <li v-for="(item, index) in listData.hangYeZiXun" :key="index" class="h3-out">
                <a :href="'/#/detail?id=' + item.ID" :title="item.post_title">
                  {{ item.post_title }}
                </a>
                <b>{{ item.post_date.split(' ')[0] }}</b>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="i_video" id="com_indexistop_videos" editok="online">
        <div class="title01">
          <ins class="ticon04"></ins>
          <h3>时事新闻</h3><span><a href="/#/shiShiXinWen" class="more">MORE</a></span></div>
        <div class="i_video_l">
          <div class="i_video_l_list">
            <ul>
              <li v-for="(item, index) in listData.shiShiXinWen" :key="index" class="h3-out">
                <a :href="'/#/detail?id=' + item.ID" :title="item.post_title"> {{ item.post_title }}</a>
                <b>{{ item.post_date.split(' ')[0] }}</b></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Footer/>
</template>

<script>
// @ is an alias to /src

import Banner from "@/components/Banner"
import Header from "@/components/Header"
import Footer from "@/components/Footer"
import http from "@/util/http"

export default {
  name: 'HomeView',
  components: {
    Footer,
    Header,
    Banner
  },
  mounted() {
    this._getList()
  },
  data() {
    return {
      listData: {}
    }
  },
  methods: {
    _getList() {
      http.get('homePage')
          .then((res) => {
            if (res.data.status === 0) {
              this.listData = res.data.data
            }
          })
    }
  }
}
</script>

<style scoped>
.h3 {
  text-overflow: ellipsis;
  font-size: 14px;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  display: inline-block;
}

.h3-out {
  line-height: 22px;
}
</style>